import { FC } from 'react'
import { HTMLInputProps } from '@blueprintjs/core'
import ctl from '@netlify/classnames-template-literals'
import cn from 'classnames'

export type TFormFieldProps = {
  label: string
  error?: string
} & HTMLInputProps

const inputClassName = ctl(`
    pt-6 pb-1 px-3
    peer font-text---20px w-full h-full
    appearance-none border-none bg-transparent
    text-palette-black focus:outline-none focus:ring-0`)

const FormField: FC<TFormFieldProps> = ({ label, error, ...inputProps }) => {
  return (
    <div
      className={cn(
        `
        relative box-border h-16 w-full border-1 border-solid 
        transition-all
        focus-within:rounded-md
        focus-within:border-1
        bg-palette-grey
        rounded-md
      `,
        error ? 'border-palette-red' : 'border-transparent border-b-palette-black focus-within:border-palette-blue',
      )}
    >
      <input {...inputProps} className={inputClassName} placeholder="" />
      <label
        className={`
          font-text---20px
          absolute left-3
          top-2
          origin-[0]
          -translate-y-2
          scale-75
          pointer-events-none
          text-palette-black transition-all
          peer-placeholder-shown:translate-y-2
          peer-placeholder-shown:scale-100
          peer-focus:-translate-y-2
          peer-focus:scale-75
          peer-focus:text-text-secondary
        `}
        htmlFor={inputProps.name}
      >
        {label ?? ''}
      </label>
      <span
        className={cn(
          ctl(
            `
              font-primary-regular---12pt absolute left-1.5 top-[calc(100%+0.25rem)]
              flex text-functional-error transition-opacity
            `,
          ),
          error ? 'opacity-100' : 'opacity-0',
        )}
      >
        {error}
      </span>
    </div>
  )
}

export { FormField }
